import apolloClient from "../services/apolloSetup";
import {
  CREATE_DESIGN,
  CREATE_VALUE_DESIGN,
  UPDATE_DESIGN,
  UPDATE_VALUE_DESIGN,
  DELETE_DESIGN,
} from "../operations/mutations/designProcess";

import useArticles from "./useArticles";

import { figurenames, webEntity } from "../constants";

import { GET_DESIGNS, GET_VALUES_DESIGN, GET_DESIGNS_ARTICLE } from "../operations/queries/designProcess";

const useProcessDesings = () => {
  const { articleData } = useArticles();

  const getDesigns = async () => {
    const response = await apolloClient.query({
      query: GET_DESIGNS(webEntity),
    });
    return response && response.data && response.data.designs;
  };

  const getDesignsArticle = async (id) => {
    const response = await apolloClient.query({
      query: GET_DESIGNS_ARTICLE(id),
    });
    return response && response.data && response.data.designsArticle;
  };

  const getDesignValues = async (id) => {
    const response = await apolloClient.query({
      query: GET_VALUES_DESIGN(id),
    });
    return response && response.data && response.data.valuesDesign;
  };

  const deleteDesign = async (id_design) => {
    return apolloClient
      .mutate({
        variables: { id_design: id_design },
        mutation: DELETE_DESIGN,
      })
      .then((r) => {
        return true;
      })
      .catch((err) => {
        return false;
      });
  };

  //Update new design
  const updateDesignProcess = async (design) => {
    const edit_design = await apolloClient.mutate({
      variables: { name: design.name, id_design: design.id_design, id_article: design.id_article },
      mutation: UPDATE_DESIGN,
    });

    const updateValuePromise = (id_variable, id_design, value) => {
      return new Promise((resolve, reject) => {
        apolloClient
          .mutate({
            mutation: UPDATE_VALUE_DESIGN,
            variables: { id_variable: id_variable, id_design: id_design, value: value.toString() },
          })
          .then(() => resolve(1))
          .catch(() => resolve(0));
      });
    };

    if (edit_design && edit_design.data && edit_design.data.updateDesign) {
      await Promise.all(design.properties.map((prop) => updateValuePromise(prop.id_variable, design.id_design, prop.value)));

      return edit_design.data.updateDesign;
    } else {
      return false;
    }
  };

  //Create new design
  const setDesignProcess = async (design) => {
    const new_design = await apolloClient.mutate({
      variables: { name: design.name, date: design.date, id_article: design.id_article },
      mutation: CREATE_DESIGN,
    });

    const newValuePromise = (id_variable, id_design, value) => {
      return new Promise((resolve, reject) => {
        apolloClient
          .mutate({
            mutation: CREATE_VALUE_DESIGN,
            variables: { id_variable: id_variable, id_design: id_design, value: value.toString() },
          })
          .then(() => resolve(1))
          .catch(() => resolve(0));
      });
    };

    if (new_design && new_design.data && new_design.data.createDesign) {
      const newValues = await Promise.all(
        design.properties.map((prop) => newValuePromise(prop.id_variable, new_design.data.createDesign, prop.value))
      );

      if (newValues.reduce((a, b) => a + b, 0) === design.properties.length) return new_design.data.createDesign;
      else return false;
    } else {
      return false;
    }
  };

  const getOneDesingData = async function (row) {
    let edit_dessign_data = {
      id: row.id_design,
      desingName: row.name,
      articleId: row.id_article.id_article,
      date: row.date,
      article: {
        articleName: row.id_article.name,
        ...row.id_article,
      },
      furnace: {},
      quenching: {},
      tempered: {},
      recommendation: {},
    };

    const response = await getDesignValues(row.id_design);

    if (response) {
      response.forEach((el) => {
        switch (el.id_variable.id_variable) {
          case 77:
            edit_dessign_data.furnace.temperature = parseInt(el.value);
            break;
          case 78:
            edit_dessign_data.furnace.heating_ramp = parseInt(el.value);
            break;
          case 79:
            edit_dessign_data.furnace.piece_temperrature = parseInt(el.value);
            break;

          case 80:
            edit_dessign_data.quenching.bath_type = el.value;
            break;
          case 81:
            edit_dessign_data.quenching.bath_temperature = parseInt(el.value);
            break;
          case 82:
            edit_dessign_data.quenching.agitation_level = parseInt(el.value);
            break;
          case 83:
            edit_dessign_data.quenching.hard_coat = parseInt(el.value);
            break;

          case 90:
            edit_dessign_data.tempered.temperature = parseInt(el.value);
            break;
          case 85:
            edit_dessign_data.tempered.heating_ramp = parseInt(el.value);
            break;
          case 86:
            edit_dessign_data.tempered.hardness_required = parseInt(el.value);
            break;

          case 87:
            edit_dessign_data.recommendation.furnace_time = parseInt(el.value);
            break;
          case 89:
            edit_dessign_data.recommendation.quenching = parseInt(el.value);
            break;
          case 88:
            edit_dessign_data.recommendation.tempered_time = parseInt(el.value);
            break;

          default:
            break;
        }
      });
    }

    const res_article_data = await articleData(row.id_article.id_article);
    let article_type = row.id_article.id_article_type.name.toLowerCase();

    let figure = {
      name: article_type,
    };

    let values = {};
    figurenames[article_type].forEach((data) => {
      let prop = res_article_data.find((el) => el.tag.trim() === data.key);
      values[data.key] = prop && prop.value && parseInt(prop.value);
    });

    res_article_data.forEach((el) => {
      if (!values[el.tag.trim()]) {
        edit_dessign_data.article[el.tag.trim()] = parseInt(el.value);
      }
    });

    figure.values = values;
    edit_dessign_data.article.figure = figure;

    return edit_dessign_data;
  };

  return {
    setDesignProcess,
    getDesigns,
    getDesignValues,
    deleteDesign,
    updateDesignProcess,
    getDesignsArticle,
    getOneDesingData,
  };
};

export default useProcessDesings;
